import { Injectable } from '@angular/core';
import { HttpRequestService } from '../_common/http-request.service';

@Injectable()
export class LineGroupService {

    constructor(private http: HttpRequestService) {
    }

    gets() {
        return this.http.get('linegroup').map(res => {
            return res.json();
        });
    }

    save(model) {
        return this.http.put('linegroup', model).map(res => {
            return res.json();
        });
    }

}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/linegroup.service.ts